import PersonOutlined from "@mui/icons-material/PersonOutlined"
import { Box, Divider, MenuItem, Stack, Typography } from "@mui/material"
import { alpha } from "@mui/material/styles"
import { useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router"

import IconButtonAnimate from "@sap/components/animate/IconButtonAnimate"
import MenuPopover from "@sap/components/menu-popover/MenuPopover"

import { useAuthStore } from "@/store/auth"

export default function AccountPopover({ background }: { background?: boolean }) {
  const { user } = useAuthStore((state) => state)

  const { t } = useTranslation("common")

  const [openPopover, setOpenPopover] = useState<HTMLButtonElement | null>(null)

  const handleOpenPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpenPopover(event.currentTarget)
  }

  const handleClosePopover = () => {
    setOpenPopover(null)
  }

  const OPTIONS = useMemo(() => {
    const links = []
    if (user?.is_pl_admin) {
      links.push({
        label: "Admin",
        linkTo: "/admin",
      })
    }
    return links
  }, [user?.is_pl_admin])

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpenPopover}
        sx={{
          p: 0,
          width: 40,
          height: 40,
          ...(background && {
            backgroundColor: "grey.200",
          }),
          ...(openPopover && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[600], 0.5),
            },
          }),
        }}
      >
        <PersonOutlined />
      </IconButtonAnimate>

      <MenuPopover open={openPopover} onClose={handleClosePopover} sx={{ width: 200, p: 0 }}>
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.first_name} {user?.last_name}
          </Typography>

          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {user?.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: "dashed" }} />

        {OPTIONS.length > 0 && (
          <>
            <Stack sx={{ p: 1 }}>
              {OPTIONS.map((option) => (
                <MenuItem
                  key={option.label}
                  component={Link}
                  to={option.linkTo}
                  onClick={handleClosePopover}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Stack>

            <Divider sx={{ borderStyle: "dashed" }} />
          </>
        )}

        <MenuItem sx={{ m: 1 }} component={Link} to="/auth/logout" onClick={handleClosePopover}>
          {t("Logout")}
        </MenuItem>
      </MenuPopover>
    </>
  )
}
